import _get from 'lodash/get'
import type { NavigationGuardNext, Route } from 'vue-router'

/**
 * Global Pennant kill-switch (HideCustomerTodoList): ACTIVE = To-Do List hidden.
 * Bootstrap value is set on window.appInitialData.features.hideCustomerTodoList
 * by TripDashboardController. Defaults to true (hidden) if missing — fail-closed.
 */
export function isCustomerTodoListHidden(): boolean {
  return _get(window, 'appInitialData.features.hideCustomerTodoList', true) === true
}

/**
 * Vue Router beforeEnter: redirect away from /todo when the kill-switch is active.
 * Matches hasPermissionOrRedirect behavior (send user to the trip home page).
 */
export function redirectIfCustomerTodoListHidden(
  to: Route,
  _from: Route,
  next: NavigationGuardNext
): void {
  if (isCustomerTodoListHidden()) {
    const dashboardId = to.params.dashboardId
    next(dashboardId ? `/trips/${dashboardId}` : '/trips/')
    return
  }
  next()
}
